/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Forms_Androidbeta_Betafulldesc3Inputs */

const id_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semua ${i?.max} tempat telah terisi. Kembali lagi nanti atau ikuti kami untuk pembaruan tentang kapan tempat tersedia lagi.`)
};

const ms_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semua ${i?.max} tempat telah diambil. Datang semula kemudian atau ikuti kami untuk kemas kini tentang bila lebih banyak tempat tersedia.`)
};

const da_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.max} pladser er optaget. Kig tilbage senere eller følg os for opdateringer om hvornår flere pladser bliver tilgængelige.`)
};

const de_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.max} Plätze sind belegt. Schauen Sie später wieder vorbei oder folgen Sie uns für Updates, wenn weitere Plätze verfügbar werden.`)
};

const en_us2_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All ${i?.max} spots have been taken. Check back later or follow us for updates on when more spots become available.`)
};

const es_es2_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Las ${i?.max} plazas han sido ocupadas. Vuelve más tarde o síguenos para estar al tanto de cuándo haya más plazas disponibles.`)
};

const es_mx2_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Los ${i?.max} lugares han sido ocupados. Vuelve más tarde o síguenos para estar al tanto de cuándo haya más lugares disponibles.`)
};

const fil_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lahat ng ${i?.max} puwesto ay napuno na. Bumalik mamaya o sundan kami para sa mga update kung kailan magkakaroon ng mga bagong puwesto.`)
};

const fr_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les ${i?.max} places ont toutes été prises. Revenez plus tard ou suivez-nous pour être informé quand de nouvelles places seront disponibles.`)
};

const it_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tutti i ${i?.max} posti sono occupati. Ripassa più tardi o seguici per sapere quando saranno disponibili nuovi posti.`)
};

const hu_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mind a ${i?.max} hely elfogyott. Nézz vissza később, vagy kövess minket a frissítésekért, hogy mikor lesznek új helyek.`)
};

const nl_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.max} plaatsen zijn bezet. Kom later terug of volg ons voor updates over wanneer er weer plaatsen beschikbaar komen.`)
};

const no_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.max} plassene er fylt opp. Kom tilbake senere eller følg oss for oppdateringer om når flere plasser blir tilgjengelige.`)
};

const pl_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wszystkie ${i?.max} miejsc zostały zajęte. Sprawdź później lub obserwuj nas, aby dowiedzieć się, kiedy pojawią się nowe miejsca.`)
};

const pt_br2_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All ${i?.max} spots have been taken. Check back later or follow us for updates on when more spots become available.`)
};

const pt_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todas as ${i?.max} vagas foram preenchidas. Volte mais tarde ou siga-nos para atualizações sobre quando mais vagas estiverem disponíveis.`)
};

const ro_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toate cele ${i?.max} locuri au fost ocupate. Revino mai târziu sau urmărește-ne pentru actualizări despre când vor fi disponibile mai multe locuri.`)
};

const fi_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kaikki ${i?.max} paikkaa on täytetty. Palaa myöhemmin tai seuraa meitä saadaksesi päivityksiä siitä, milloin lisää paikkoja tulee saataville.`)
};

const sv_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alla ${i?.max} platser har tagits. Kom tillbaka senare eller följ oss för uppdateringar om när fler platser blir tillgängliga.`)
};

const vi_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tất cả ${i?.max} chỗ đã được lấy. Quay lại sau hoặc theo dõi chúng tôi để biết khi nào có thêm chỗ.`)
};

const tr_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.max} kontenjanın tamamı doldu. Daha sonra tekrar gelin veya daha fazla kontenjan açıldığında haber almak için bizi takip edin.`)
};

const cs_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Všech ${i?.max} míst bylo obsazeno. Vraťte se později nebo nás sledujte pro informace o tom, kdy budou k dispozici další místa.`)
};

const bg_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Всички ${i?.max} места са заети. Върнете се по-късно или ни следвайте за актуализации кога ще има повече места.`)
};

const ru_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Все места (${i?.max}) заняты. Загляните позже или следите за нами, чтобы узнать, когда появятся новые места.`)
};

const uk_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Усі ${i?.max} місць зайняті. Повертайтеся пізніше або слідкуйте за нами, щоб дізнатися про нові місця.`)
};

const ar_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تم أخذ جميع المقاعد ${i?.max}. عد لاحقًا أو تابعنا لمعرفة متى تتوفر مقاعد إضافية.`)
};

const hi_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सभी ${i?.max} स्थान भर गए। बाद में वापस आएँ या अपडेट के लिए हमें फॉलो करें।`)
};

const th_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.max} ที่นั่งทั้งหมดถูกจับแล้ว กลับมาตรวจสอบภายหลังหรือติดตามเราเพื่อรับข่าวสารเมื่อมีที่นั่งเพิ่มเติม`)
};

const ja_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.max} 枠すべてが埋まりました。後日再度チェックするか、枠が追加されたときにフォローしてください。`)
};

const zh_cn2_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All ${i?.max} spots have been taken. Check back later or follow us for updates on when more spots become available.`)
};

const zh_hant1_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All ${i?.max} spots have been taken. Check back later or follow us for updates on when more spots become available.`)
};

const ko_forms_androidbeta_betafulldesc3 = /** @type {(inputs: Forms_Androidbeta_Betafulldesc3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All ${i?.max} spots have been taken. Check back later or follow us for updates on when more spots become available.`)
};

/**
* | output |
* | --- |
* | "All {max} spots have been taken. Check back later or follow us for updates on when more spots become available." |
*
* @param {Forms_Androidbeta_Betafulldesc3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_betafulldesc3 = /** @type {((inputs: Forms_Androidbeta_Betafulldesc3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Betafulldesc3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "ms") return ms_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "da") return da_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "de") return de_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "fil") return fil_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "fr") return fr_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "it") return it_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "hu") return hu_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "nl") return nl_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "no") return no_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "pl") return pl_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "pt") return pt_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "ro") return ro_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "fi") return fi_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "sv") return sv_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "vi") return vi_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "tr") return tr_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "cs") return cs_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "bg") return bg_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "ru") return ru_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "uk") return uk_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "ar") return ar_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "hi") return hi_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "th") return th_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "ja") return ja_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_betafulldesc3(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_betafulldesc3(inputs)
	return ko_forms_androidbeta_betafulldesc3(inputs)
});
export { forms_androidbeta_betafulldesc3 as "forms.androidBeta.betaFullDesc" }